import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'

const centerVertically = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}

const Container = styled(Box)(({theme}) => {
  return {
    "&.MuiBox-root": {
      marginTop: 30,
      flexGrow: 1,
    },
    "& .groupLinksWrapper": {
      marginLeft: 30,
      flexShrink: 0
    },
    "& .unit": {
      "&.expanded": {
        borderTop: 'solid 2px #dddddd'
      },
      textDecoration: 'none',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff'
    },
    "& .unitSummary": {
      display: 'flex',
      padding: '10px 20px',
      "&.expanded": {
        borderBottom: 'solid 1px #dddddd',
      },
      "& .assessment": {
        marginRight: 27
      },
      "& .unitName": {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        color: '#565f77',
        fontSize: '13.5pt',
        flexShrink: 1,
        "&.expanded": {
          fontWeight: 600
        }
      },
    },
    "& .unitDetails": {
      backgroundColor: '#f6fbfe',
      padding: 20,
      paddingRight: 50
    },
  }}
)

export {Container as default}
